import React, {lazy} from "react";
const Home = lazy(() => import ("./pages/Home/Home.js"));
const About = lazy(() => import ("./pages/About/About.js"));
const Blog = lazy(() => import ("./pages/Blog/Blog.js"));
const Videos = lazy(() => import ("./pages/Videos/Videos.js"));
const ContactUs = lazy(() => import ("./pages/Contact/ContactUs.js"));
const ArticleDetails = lazy(() => import ("./pages/Blog/ArticleDetails.js"));

const AppRoutes = [
    {
        path: "/",
        element: <Home/>
    },
    {
        path: "/about",
        element: <About/>
    },
    {
        path: "/blog",
        element: <Blog/>
    },
    {
        path: "/videos",
        element: <Videos/>
    },
    {
        path: "/contact",
        element: <ContactUs/>
    },
    {
        path: "/blog/:id",
        element: <ArticleDetails/>
    },
    {
        path: "*",
        element: <div>Not Found</div>
    }
];

export default AppRoutes